module.exports = __webpack_public_path__ + "static/media/picture2.4b481d3c.jpg";